var vars = require('./core');

module.exports = vars.createClass('PolarArea', ['getSegmentsAtEvent']);



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-chartjs/lib/polar-area.js
 ** module id = 972
 ** module chunks = 2
 **/